<app-navbar></app-navbar>
<section>
    <div class="container" style="padding: 100px;">
      <div class="row">
            <div class="col-md-12">
                <div class="dashboard">
                    <div class="publication">
                      <img src="assets/img/school/logo.png" alt="Publication 1">
                      <h3>Publication 1</h3>
                      <p>Description of Publication 1</p>
                    </div>
                    <div class="publication">
                      <img src="assets/img/school/logo.png" alt="Publication 2">
                      <h3>Publication 2</h3>
                      <p>Description of Publication 2</p>
                    </div>
                    <!-- Add more publication items here -->
                  </div>
            
            </div>
          </div>
        </div>
  </section>
            
        
         

